import { Link } from 'react-router-dom';
import { categories } from '@/mocks/home';

export default function CategoryNavSection() {
  return (
    <section className="w-full px-4 md:px-6 lg:px-12 py-14 md:py-20 bg-background-100">
      <div className="flex flex-col lg:flex-row lg:items-end gap-4 mb-10">
        <h2 className="text-3xl md:text-4xl font-heading text-foreground-950">
          分类导航
        </h2>
        <p className="text-sm text-foreground-600 lg:ml-8">
          按类型快速找到你想看的动漫，国产、日本、剧场版一应俱全
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
        {categories.map((cat, idx) => (
          <Link
            key={cat.id}
            to={`/category/${cat.slug}`}
            className={`group rounded-lg overflow-hidden bg-background-50 hover:bg-background-50/80 transition-colors ${
              idx === 0 ? 'md:col-span-1' : ''
            }`}
          >
            <div className="relative w-full h-[200px] md:h-[240px] overflow-hidden">
              <img
                src={cat.image}
                alt={cat.name}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4">
                <div className="flex items-center gap-2 mb-1">
                  <div className="w-7 h-7 rounded-lg bg-primary-500 flex items-center justify-center">
                    <i className={`${cat.icon} text-background-50 text-sm`}></i>
                  </div>
                  <h3 className="text-lg font-heading text-background-50">{cat.name}</h3>
                </div>
                <p className="text-xs text-background-200">{cat.count} 部作品</p>
              </div>
            </div>
            <div className="p-4">
              <p className="text-sm text-foreground-600">{cat.description}</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}